import { Directive } from "@angular/core";
import { MatSelect } from "@angular/material/select";
import { MatLegacySelect } from "@angular/material/legacy-select";

/**
 * ngx-mat-select-search v7 is the MDC build and injects the modern
 * `MatSelect` (@angular/material/select), but this app uses the legacy
 * `<mat-select>` (MatLegacySelect). This directive aliases the modern
 * MatSelect token to the legacy select instance on the same element,
 * so the search component resolves. Both share the same _MatSelectBase
 * API that ngx-mat-select-search relies on.
 *
 * TEMP FIX: Declared only in DashboardModule, so it is scoped to this module.
 */
@Directive({
	selector: "mat-select",
	providers: [{ provide: MatSelect, useExisting: MatLegacySelect }]
})
export class LegacySelectSearchCompatDirective {}
